import useAsset from './useAsset';
export const useProjectStatusColors = () => {
  const asset = useAsset();
  return {
    OneTime: {
      [asset.constants.STATUS_DRAFT]: 'gray.300',
      [asset.constants.STATUS_ACTIVE]: 'green.400',
      [asset.constants.STATUS_PAUSED]: 'warning.500',
      [asset.constants.STATUS_COMPLETE]: 'teal.500',
      [asset.constants.STATUS_ARCHIVED]: 'gray.500',
    },
    Recurring: {
      [asset.constants.PROJECT_SCHEDULE_STATUS_DRAFT]: 'gray.300',
      [asset.constants.PROJECT_SCHEDULE_STATUS_ACTIVE]: 'green.400',
      [asset.constants.PROJECT_SCHEDULE_STATUS_PAUSED]: 'warning.500',
      [asset.constants.PROJECT_SCHEDULE_STATUS_COMPLETE]: 'teal.500',
      [asset.constants.PROJECT_SCHEDULE_STATUS_ARCHIVED]: 'gray.500',
    },
  } as const;
};
